import { render, staticRenderFns } from "./geneJiedu.vue?vue&type=template&id=5f132cf9&scoped=true"
import script from "./geneJiedu.vue?vue&type=script&lang=js"
export * from "./geneJiedu.vue?vue&type=script&lang=js"
import style0 from "./geneJiedu.vue?vue&type=style&index=0&id=5f132cf9&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f132cf9",
  null
  
)

export default component.exports